"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var icons = require("./../../../styles/att-icons.css");
var styles = require("./PasswordEye.css");
var PasswordEye = /** @class */ (function (_super) {
    __extends(PasswordEye, _super);
    function PasswordEye(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        _this.state = { enable: true, inFocus: false, parentInFocus: _this.props.data.isFocused };
        return _this;
    }
    PasswordEye.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps.data.isFocused !== this.state.parentInFocus) {
            this.setState({ parentInFocus: nextProps.data.isFocused });
        }
    };
    PasswordEye.prototype.render = function () {
        return (React.createElement("button", { className: [
                styles.eyeContainer,
                this.getEyeClass(),
                this.getColorClass(),
            ].join(' '), "data-test-id": this.props.testId, onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur, "aria-label": this.state.enable ? 'Password masking on' : 'Password masking off' },
            React.createElement("i", { className: [
                    icons.attIcon,
                    this.state.enable ?
                        icons.attIconEye :
                        icons.attIconEyeHide
                ].join(' ') })));
    };
    PasswordEye.prototype.onFocus = function () {
        this.setState({ inFocus: true });
    };
    PasswordEye.prototype.onBlur = function () {
        this.setState({ inFocus: false });
    };
    PasswordEye.prototype.onClick = function () {
        if (this.props.events) {
            if (this.state.enable) {
                this.props.events.maskDisabled();
            }
            else {
                this.props.events.maskEnabled();
            }
        }
        this.setState({ enable: !this.state.enable });
    };
    PasswordEye.prototype.getColorClass = function () {
        return (this.state.parentInFocus || this.state.inFocus) ?
            styles.focused :
            styles.blurred;
    };
    PasswordEye.prototype.getEyeClass = function () {
        return this.props.data &&
            this.props.data.withTooltip ?
            styles.withTooltip :
            styles.withoutTooltip;
    };
    return PasswordEye;
}(React.Component));
exports.default = PasswordEye;
//# sourceMappingURL=PasswordEye.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/PasswordEye/PasswordEye.js
// module id = 1210
// module chunks = 8